export const TEMPLATE_FETCH_SUCCESS = "TEMPLATE_FETCH_SUCCESS";
export const TEMPLATE_FETCH_FAILURE = "TEMPLATE_FETCH_FAILURE";
export const TEMPLATE_SAVE_SUCCESS = "TEMPLATE_SAVE_SUCCESS";
export const TEMPLATE_SAVE_FAILURE = "TEMPLATE_SAVE_FAILURE";
export const TEMPLATE_DESTROY_SUCCESS = "TEMPLATE_DESTROY_SUCCESS";
export const TEMPLATE_DESTROY_FAILURE = "TEMPLATE_DESTROY_FAILURE";
export const TEMPLATE_SAVE_REQUEST = "TEMPLATE_SUBMITTING";
